/*
 * @Author: 肖玲
 * @Date: 2023-03-01 13:44:53
 * @LastEditTime: 2023-03-01 19:05:58
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\flow-direction-data-query\modules\rawDataStatisticRouter.js
 * 原始数据统计路由
 */

// 和原始数据共用路由
const rawDataStatisticRouter = []
export default rawDataStatisticRouter
